<template>
  <div class="web-root">
    <div class="page-container">
      <div v-if="env.isApp" class="custom-nav-block" :style="`padding-top:${barHeight}px`">
        <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
          <template #left>
            <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
          </template>
        </van-nav-bar>
      </div>
      <iframe v-if="packageName === 'echo'" id="offical-web-iframe" src="/official_site/echo/index.html" frameborder="0" @load="handleLoaded" />
      <iframe v-if="packageName === 'joychat'" id="offical-web-iframe" src="/official_site/joychat/index.html" frameborder="0" @load="handleLoaded" />
      <iframe v-if="packageName === 'joyu'" id="offical-web-iframe" src="/official_site/joyu/index.html" frameborder="0" @load="handleLoaded" />
      <iframe v-if="packageName === 'kiko'" id="offical-web-iframe" src="/official_site/kiko/index.html" frameborder="0" @load="handleLoaded" />
      <iframe v-if="packageName === 'vava'" id="offical-web-iframe" src="https://www.vava.chat/index.html" frameborder="0" @load="handleLoaded" />
      <iframe v-if="packageName === 'vibeo'" id="offical-web-iframe" src="/official_site/vibeo/index.html" frameborder="0" @load="handleLoaded" />
      <iframe v-if="packageName === 'whonow'" id="offical-web-iframe" src="/official_site/whonow/index.html" frameborder="0" @load="handleLoaded" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {
    this._handleIframeMsg = (e) => {
      if (e.origin !== 'https://www.vava.chat') return
      if (e.data && e.data.type === 'VAVA_START_CHAT') {
        window.location.href = e.data.url || 'https://web.vava.chat'
      }
    }
    window.addEventListener('message', this._handleIframeMsg)
  },
  beforeDestroy() {
    window.removeEventListener('message', this._handleIframeMsg)
  },
  methods: {
    handleLoaded() {
      try {
        // 设置facebook-domain-verification
        const iframeEle = document.getElementById('offical-web-iframe')
        if (iframeEle && iframeEle.contentWindow) {
          const metaTag = iframeEle.contentWindow.document.querySelector('meta[name="facebook-domain-verification"]')
          if (metaTag) {
            const verificationCode = metaTag.getAttribute('content')
            const meta = document.createElement('meta')
            meta.name = 'facebook-domain-verification'
            meta.content = verificationCode
            document.head.appendChild(meta)
          }
        }
      } catch (error) {
        console.log('try catch error:', error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.web-root {
  width: 100%;
  height: 100vh;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  .page-container {
    box-sizing: border-box;
    background-color: #000000;
    padding: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    .mobile-bar {
      width: 100%;
    }
    #offical-web-iframe {
      flex: 1;
      width: 100%;
    }
  }
}
</style>
